'use client';

import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import MaterialLink from '../material-link';
import { DISCORD_ENABLED } from '../../constants/DISCORD_ENABLED';

const SidebarDiscord = () => {
  if (!DISCORD_ENABLED) {
    return null;
  }

  return (
    <>
      <Divider />
      <Box sx={{ px: 2, py: 1.5, display: 'flex', alignItems: 'center', gap: 1 }}>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          width="18"
          height="18"
          src="/static/discord-brands.svg"
          alt=""
          style={{ opacity: 0.6 }}
        />
        <MaterialLink
          href="/discord"
          underline="hover"
          color="text.secondary"
          variant="body2"
        >
          Get notified on Discord
        </MaterialLink>
      </Box>
    </>
  );
};

export default SidebarDiscord;
